import { Component, inject, signal } from '@angular/core';
import { form, FormField, required, submit } from '@angular/forms/signals';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';

import { LocationsActionsService } from '@app/shared/services/locations-actions.service';
import {
  AddMultipleLocationsFormModel,
  AddProjectLocationDialogData
} from '@app/shared/types/models/location/location.model';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { UiInputComponent } from '@app/shared/ui/input/ui-input.component';
import { TranslatePipe } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'proffeo-add-multiple-sublocation-dialog',
  imports: [MatDialogModule, TranslatePipe, UiDialogComponent, FormField, UiInputComponent, UiButtonComponent],
  templateUrl: './add-multiple-sublocation-dialog.component.html'
})
export class AddMultipleSublocationDialogComponent {
  private readonly locationsActionsService: LocationsActionsService = inject(LocationsActionsService);
  private readonly dialogRef: MatDialogRef<AddMultipleSublocationDialogComponent> = inject(
    MatDialogRef<AddMultipleSublocationDialogComponent>
  );
  private readonly dialogData: AddProjectLocationDialogData = inject(MAT_DIALOG_DATA);

  protected readonly model = signal<AddMultipleLocationsFormModel>({ name: '', amount: null, numbering: null });
  protected readonly form = form(this.model, path => {
    required(path.name);
    required(path.amount);
    required(path.numbering);
  });

  public save(): void {
    void submit(this.form, {
      action: async () => {
        const { name, amount, numbering } = this.model();
        try {
          await firstValueFrom(
            this.locationsActionsService.addMultipleLocations(
              name,
              Math.trunc(amount!),
              Math.trunc(numbering!),
              this.dialogData.parentId
            )
          );
          this.dialogRef.close();
        } catch {
          // HTTP errors are reported globally; the dialog stays open for a retry.
        }
      }
    });
  }
}
